import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { LoadingContext, M_Table, NavigateContext } from 'src/M_Components'

export const BookingEquipmentList = ({ roles }) => {
    const { t } = useTranslation()
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)

    const newRoute = (url, operation, label, row) => {
        if (operation === 'Edit' || operation === 'Copy') {
            if (row) {
                sessionStorage.setItem('editingBookingEquipment', JSON.stringify(row))
                sessionStorage.setItem('operationType', operation)  
            } else {
                return
            }
        }
        if (operation === 'Create') ctx.setPassValues({ Operation: operation })
        ctx2.newTab(url, label)
    }

    return (
        <M_Table
            entityName={'BookingEquipment'}
            showTitle={true}
            title={'Booking Equipment'} 
            roleName={'usersGroups'}
            rolePermissions={roles}
            removeContextItems={['Create','Copy', 'Edit']}
            replaceFunctions={new Map([
                ['Create', (row) => newRoute('go/bookingEquipmentCrud', 'Create', t('Add')+' '+t('Equipment')+' '+ t('Class'), row)],
                ['Edit', (row) => newRoute('go/bookingEquipmentCrud', 'Edit', t('Edit')+' '+t('Equipment')+' '+ t('Class'), row)],
                ['Copy', (row) => newRoute('go/bookingEquipmentCrud', 'Copy', t('Copy')+' '+t('Equipment')+' '+ t('Class'), row)]
            ])}
        />
    )
}